/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ErrorResponse } from '../model/errorResponse';
// @ts-ignore
import { NotificationGroupMessageIdResponse } from '../model/notificationGroupMessageIdResponse';
// @ts-ignore
import { NotificationMessageDetailedResponse } from '../model/notificationMessageDetailedResponse';
// @ts-ignore
import { NotificationMessagePaginatedResponse } from '../model/notificationMessagePaginatedResponse';
// @ts-ignore
import { NotificationMessageRequest } from '../model/notificationMessageRequest';
// @ts-ignore
import { NotificationValidationResponse } from '../model/notificationValidationResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class NotificationOperatorService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Operator API to search the notification messages
     * Search API for Email and InApp notification messages
     * @param serviceType Service Type
     * @param orgId ORG identifier
     * @param state Message Delivery State
     * @param messageType Message Type
     * @param origin Request Origin
     * @param from Search Notification Message beginning from Start Date
     * @param to Search Notification Message till this Start Date
     * @param search Free Text Search
     * @param resourceId resource identifier
     * @param resourceAction Resource Action
     * @param messageGroupId Message Group identifier for filtering notifications sent as part of a bulk request
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getVcdsMessageSearchOperator(serviceType: 'VCDR' | 'VMCFS' | 'VMUA', orgId?: string, state?: 'RECEIVED' | 'PREPARED' | 'SUBMITTED' | 'DELIVERED' | 'RETRY' | 'PUBLISH_FAILED' | 'DELIVERY_FAILED' | 'ASSUMED_DELIVERED', messageType?: 'EMAIL' | 'BANNER' | 'TOAST', origin?: 'SYSTEM' | 'OPERATOR', from?: string, to?: string, search?: string, resourceId?: string, resourceAction?: 'UNKNOWN' | 'NONE' | 'ACTIVATION_SUCCESS' | 'ACTIVATION_FAILED' | 'DEACTIVATION_INITIATED' | 'DEACTIVATION_SUCCESS' | 'DEACTIVATION_FAILED' | 'REQUEST_ACCESS_SUCCESS' | 'REQUEST_ACCESS_FAILED' | 'REQUEST_ACCESS_GRANTED' | 'REQUEST_ACCESS_DENIED' | 'UPGRADE_INITIATED' | 'UPGRADE_SUCCESS' | 'UPGRADE_FAILED' | 'SUBSCRIPTION_ACTIVATION_SUCCESS' | 'SUBSCRIPTION_EXPIRING' | 'SUBSCRIPTION_EXPIRED' | 'MAINTENANCE_SCHEDULED' | 'MAINTENANCE_UPDATED' | 'MAINTENANCE_CANCELED' | 'MAINTENANCE_COMPLETED', messageGroupId?: string, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<NotificationMessagePaginatedResponse>;
    public getVcdsMessageSearchOperator(serviceType: 'VCDR' | 'VMCFS' | 'VMUA', orgId?: string, state?: 'RECEIVED' | 'PREPARED' | 'SUBMITTED' | 'DELIVERED' | 'RETRY' | 'PUBLISH_FAILED' | 'DELIVERY_FAILED' | 'ASSUMED_DELIVERED', messageType?: 'EMAIL' | 'BANNER' | 'TOAST', origin?: 'SYSTEM' | 'OPERATOR', from?: string, to?: string, search?: string, resourceId?: string, resourceAction?: 'UNKNOWN' | 'NONE' | 'ACTIVATION_SUCCESS' | 'ACTIVATION_FAILED' | 'DEACTIVATION_INITIATED' | 'DEACTIVATION_SUCCESS' | 'DEACTIVATION_FAILED' | 'REQUEST_ACCESS_SUCCESS' | 'REQUEST_ACCESS_FAILED' | 'REQUEST_ACCESS_GRANTED' | 'REQUEST_ACCESS_DENIED' | 'UPGRADE_INITIATED' | 'UPGRADE_SUCCESS' | 'UPGRADE_FAILED' | 'SUBSCRIPTION_ACTIVATION_SUCCESS' | 'SUBSCRIPTION_EXPIRING' | 'SUBSCRIPTION_EXPIRED' | 'MAINTENANCE_SCHEDULED' | 'MAINTENANCE_UPDATED' | 'MAINTENANCE_CANCELED' | 'MAINTENANCE_COMPLETED', messageGroupId?: string, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<NotificationMessagePaginatedResponse>>;
    public getVcdsMessageSearchOperator(serviceType: 'VCDR' | 'VMCFS' | 'VMUA', orgId?: string, state?: 'RECEIVED' | 'PREPARED' | 'SUBMITTED' | 'DELIVERED' | 'RETRY' | 'PUBLISH_FAILED' | 'DELIVERY_FAILED' | 'ASSUMED_DELIVERED', messageType?: 'EMAIL' | 'BANNER' | 'TOAST', origin?: 'SYSTEM' | 'OPERATOR', from?: string, to?: string, search?: string, resourceId?: string, resourceAction?: 'UNKNOWN' | 'NONE' | 'ACTIVATION_SUCCESS' | 'ACTIVATION_FAILED' | 'DEACTIVATION_INITIATED' | 'DEACTIVATION_SUCCESS' | 'DEACTIVATION_FAILED' | 'REQUEST_ACCESS_SUCCESS' | 'REQUEST_ACCESS_FAILED' | 'REQUEST_ACCESS_GRANTED' | 'REQUEST_ACCESS_DENIED' | 'UPGRADE_INITIATED' | 'UPGRADE_SUCCESS' | 'UPGRADE_FAILED' | 'SUBSCRIPTION_ACTIVATION_SUCCESS' | 'SUBSCRIPTION_EXPIRING' | 'SUBSCRIPTION_EXPIRED' | 'MAINTENANCE_SCHEDULED' | 'MAINTENANCE_UPDATED' | 'MAINTENANCE_CANCELED' | 'MAINTENANCE_COMPLETED', messageGroupId?: string, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<NotificationMessagePaginatedResponse>>;
    public getVcdsMessageSearchOperator(serviceType: 'VCDR' | 'VMCFS' | 'VMUA', orgId?: string, state?: 'RECEIVED' | 'PREPARED' | 'SUBMITTED' | 'DELIVERED' | 'RETRY' | 'PUBLISH_FAILED' | 'DELIVERY_FAILED' | 'ASSUMED_DELIVERED', messageType?: 'EMAIL' | 'BANNER' | 'TOAST', origin?: 'SYSTEM' | 'OPERATOR', from?: string, to?: string, search?: string, resourceId?: string, resourceAction?: 'UNKNOWN' | 'NONE' | 'ACTIVATION_SUCCESS' | 'ACTIVATION_FAILED' | 'DEACTIVATION_INITIATED' | 'DEACTIVATION_SUCCESS' | 'DEACTIVATION_FAILED' | 'REQUEST_ACCESS_SUCCESS' | 'REQUEST_ACCESS_FAILED' | 'REQUEST_ACCESS_GRANTED' | 'REQUEST_ACCESS_DENIED' | 'UPGRADE_INITIATED' | 'UPGRADE_SUCCESS' | 'UPGRADE_FAILED' | 'SUBSCRIPTION_ACTIVATION_SUCCESS' | 'SUBSCRIPTION_EXPIRING' | 'SUBSCRIPTION_EXPIRED' | 'MAINTENANCE_SCHEDULED' | 'MAINTENANCE_UPDATED' | 'MAINTENANCE_CANCELED' | 'MAINTENANCE_COMPLETED', messageGroupId?: string, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (serviceType === null || serviceType === undefined) {
            throw new Error('Required parameter serviceType was null or undefined when calling getVcdsMessageSearchOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>state, 'state');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>messageType, 'message-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>origin, 'origin');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>from, 'from');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>to, 'to');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>search, 'search');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>resourceId, 'resource-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>resourceAction, 'resource-action');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>messageGroupId, 'message-group-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/notification/message`;
        return this.httpClient.request<NotificationMessagePaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Operator API to check message status of a specific message id
     * Fetch Email or InApp message corresponding to the provided message id
     * @param messageId Message Id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getVcdsMessageStatusForMessageIdOperator(messageId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<NotificationMessageDetailedResponse>;
    public getVcdsMessageStatusForMessageIdOperator(messageId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<NotificationMessageDetailedResponse>>;
    public getVcdsMessageStatusForMessageIdOperator(messageId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<NotificationMessageDetailedResponse>>;
    public getVcdsMessageStatusForMessageIdOperator(messageId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (messageId === null || messageId === undefined) {
            throw new Error('Required parameter messageId was null or undefined when calling getVcdsMessageStatusForMessageIdOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/notification/message/${this.configuration.encodeParam({name: "messageId", value: messageId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        return this.httpClient.request<NotificationMessageDetailedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Operator API to publish the notification message
     * InApp or Email notification messages could be generated using this API
     * @param notificationMessageRequest It represents the object for notification message publication
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postVcdsNotificationMessageOperator(notificationMessageRequest: NotificationMessageRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<NotificationGroupMessageIdResponse>;
    public postVcdsNotificationMessageOperator(notificationMessageRequest: NotificationMessageRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<NotificationGroupMessageIdResponse>>;
    public postVcdsNotificationMessageOperator(notificationMessageRequest: NotificationMessageRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<NotificationGroupMessageIdResponse>>;
    public postVcdsNotificationMessageOperator(notificationMessageRequest: NotificationMessageRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (notificationMessageRequest === null || notificationMessageRequest === undefined) {
            throw new Error('Required parameter notificationMessageRequest was null or undefined when calling postVcdsNotificationMessageOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/notification/message`;
        return this.httpClient.request<NotificationGroupMessageIdResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: notificationMessageRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Operator API to publish the notification message
     * InApp or Email notification messages could be generated using this API
     * @param notificationMessageRequest It represents the object for notification message publication
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postVcdsNotificationMessageValidateOperator(notificationMessageRequest: NotificationMessageRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<NotificationValidationResponse>;
    public postVcdsNotificationMessageValidateOperator(notificationMessageRequest: NotificationMessageRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<NotificationValidationResponse>>;
    public postVcdsNotificationMessageValidateOperator(notificationMessageRequest: NotificationMessageRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<NotificationValidationResponse>>;
    public postVcdsNotificationMessageValidateOperator(notificationMessageRequest: NotificationMessageRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (notificationMessageRequest === null || notificationMessageRequest === undefined) {
            throw new Error('Required parameter notificationMessageRequest was null or undefined when calling postVcdsNotificationMessageValidateOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/notification/message/validate`;
        return this.httpClient.request<NotificationValidationResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: notificationMessageRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
